<style>
html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
  background-color: #f5f8ff;
  overflow: auto;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}
</style>

<template>
  <div class="flex-col page">
    <div class="container">
      <div class="haderView">
        <div class="title">审核通过!</div>
        <div class="subtitle">您已通过【{{ this.productName }}】的初审</div>
      </div>
      <div class="content flex-col items-center">
        <div class="amount flex-row justify-between">
          <span class="amount_title">借款金额</span>
          <span class="amount_lab">¥{{ this.recommendProduct.number }}</span>
        </div>
        <van-divider
          :style="{
            color: '#EEEEEE',
            borderColor: '#EEEEEE',
            padding: '0 0.3rem',
          }"
        >
        </van-divider>
        <div class="periods flex-row justify-between">
          <span class="periods_title">还款期数</span>
          <van-dropdown-menu active-color="#ee0a24" :overlay="false">
            <van-dropdown-item
              v-model="dropdownValue"
              :options="dropdownOption"
              @change="changeOption"
            />
          </van-dropdown-menu>
        </div>
        <div class="info flex-col">
          <div class="info-list flex-row justify-between">
            <div class="info-item flex-col justify-between items-center">
              <span class="info-item-lab">{{ this.interest }}元</span>
              <span class="info-item-text">预估利息</span>
            </div>
            <div class="info-item flex-col justify-between items-center">
              <span class="info-item-lab">{{ this.monthlyPayment }}元</span>
              <span class="info-item-text">月还款</span>
            </div>
            <div class="info-item flex-col justify-between items-center">
              <span class="info-item-lab">{{ this.showRate }}%</span>
              <span class="info-item-text">年利率</span>
            </div>
          </div>
        </div>
        <div class="audit-tag"></div>
        <div class="tag-list flex-row">
          <div
            class="tag-item flex-col"
            v-for="(item, index) in tagArray"
            :key="index"
          >
            <img
              class="tag-icon"
              referrerpolicy="no-referrer"
              :src="item.icon"
            />
            <span class="tag-text" v-html="item.text"></span>
          </div>
        </div>
        <div class="audit-footer flex-col items-center justify-center">
          <div
            class="protocol-button"
            @click="handleLoginProtocol"
            v-if="isProtocol"
          >
            《{{ recommendProduct.protocolName }}》
          </div>

          <button
            class="flex-col justify-center items-center func-button"
            @click="handleSubmit"
          >
            <span class="font_2 text_18">{{ btnTxt }}</span>
          </button>
          <div class="download-button" @click="handleDownload">
            下载APP匹配更多资金
          </div>
        </div>
      </div>
    </div>
    <!--    cpa弹窗-->
    <van-popup
      v-model="isShowPop"
      position="center"
      round
      v-if="this.popData.productName"
    >
      <div class="pop-countent">
        <div class="title-bg">
          <span class="title-text">点击去提现，立即拿钱</span>
          <span class="span-icon"></span>
        </div>
        <div class="countent">
          <img :src="this.popData.logo" class="product-logo" />
          <div class="product-infoBg flex-col justify-center">
            <div class="product-info">
              <div class="product-name">{{ popData.productName }}</div>
              <div class="product-num">{{ popData.loanAmount }}元</div>
            </div>
            <div class="product-tip flex-row items-center">
              <div class="product-tipImg"></div>
              <div class="product-tipTitle">秒申请，秒审核！两小时内放款</div>
            </div>
          </div>
        </div>
        <div class="agree-txt">
          <van-checkbox
            v-model="checked"
            class="check-box"
            shape="square"
          ></van-checkbox>
          <span class="txt"
            >我已阅读并同意<i
              @click="
                model === 'modeldlb' ? handleProtocol(22) : handleProtocol(9)
              "
              >《个人信息查询授权书》</i
            >
            <i
              v-if="popData.protocolUrl"
              @click="handlePopLoginProtocol"
              style="display: block"
            >
              《{{ recommendProduct.protocolName }}》
            </i></span
          >
        </div>
        <div class="btn-bg flex-row items-center justify-center">
          <div
            class="btn-cancel flex-row items-center justify-center"
            @click="handleCancelBtn"
          >
            确认离开
          </div>
          <div
            class="btn-confirm flex-row items-center justify-center"
            v-prevent-reclick
            @click="handlePopBtn"
          >
            去提现
          </div>
        </div>
      </div>
    </van-popup>
    <!--    协议弹窗-->
    <div class="po_section_1 flex-col po_bg" v-show="isShowProtocol">
      <div class="po_block_1 flex-col">
        <div class="po_box_1 flex-col">
          <img
            class="po_thumbnail_1"
            referrerpolicy="no-referrer"
            src="../../assets/images/model8/model8_po_close.png"
            v-on:click="handelCloseProtocol"
          />
          <div class="po_text-group_1 flex-col justify-between">
            <span class="po_text_1">请阅读以下协议</span>
          </div>
          <div class="flex-col po_content justify-between">
            <span class="contentText" v-html="apiProduct.content"> </span>
          </div>
          <button
            class="po_button_1 flex-col"
            @click="handelAgreeProtocol"
            v-prevent-reclick
          >
            <span class="po_text_2">我已阅读并同意授权</span>
          </button>
        </div>
      </div>
    </div>
    <!-- 提示浏览器打开遮罩层 -->
    <van-overlay :show="showPop" @click="handlePopChange">
      <div class="share-pop">
        <img
          class="icon-share"
          src="../../assets/images/icon_share.png"
          alt=""
        />
        <div class="share-font-box">
          <div class="share-font">
            链接无法打开？<br />点击右上角“...”，复制链接到浏览器中打开。
          </div>
          <div
            class="share-btn u-flex u-row-center u-col-center"
            @click.stop="handleClose"
          >
            我知道啦
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script src="././public/js/base.js"></script>
<script src="./src/css/modelBase.css"></script>
<script src="./src/utils/preventReClick.js"></script>
<script>
import Vue from "vue";
import {
  addDownloadRecord,
  toRedirectUrlAndSaveRecordNoDebounce,
} from "@/api/common";
import SharePop from "@/components/SharePop";
import * as API_Common from "@/api/common.js";
import Clipboard from "clipboard";
import ClipboardJS from "clipboard";
export default {
  name: "userAuditBlue",
  components: {
    SharePop,
  },
  data() {
    return {
      channel: this.$route.query.source,
      model: sessionStorage.getItem("model"),
      isShowPop:
        !window.localStorage.getItem("closePop") &&
        window.localStorage.getItem("backFlag"),
      periods: "12期",
      dropdownValue: 2,
      interest: 0, //预估利息
      monthlyPayment: 0, //月还款
      rate: 0.12,
      showRate: 0,
      checked: false,
      isShowProtocol: false,
      isClickProtocol: false,
      downAppUrl: "",
      showPop: false, //微信渠道提示弹窗
      isProtocol: false,
      productName: "",
      productLogo: "",
      popData: {
        productId: 0,
        productName: "",
        loanRate: 0,
        loanAmount: "",
        loanPeriod: "",
        loanMinRate: 0,
        isShieldCity: false,
        linkUrl: undefined,
        isToRegister: undefined,
        protocolName: undefined,
        protocolUrl: undefined,
      },
      recommendProduct: {
        id: "",
        name: "",
        settlementType: 0,
        price: 0,
        linkUrl: "",
        sort: 0,
        imgUrl: "",
        number: 0,
        minLoanRate: 0,
        maxLoanRate: 0,
        isToRegister: 0,
        prodFeature: "",
        companyName: "",
        protocolName: undefined,
        protocolUrl: undefined,
      },

      btnTxt: "立即下载",
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        redirectUrl: "",
        grantValue: "",
      },
      unionLogin: {
        productId: 0,
        url: "",
      },
      tagArray: [
        {
          icon: require("../../assets/images/userAuditBlue/icon1.png"),
          text: "下载app",
        },
        {
          icon: require("../../assets/images/userAuditBlue/icon2.png"),
          text: "填写信息",
        },
        {
          icon: require("../../assets/images/userAuditBlue/icon3.png"),
          text: "绑定银行卡",
        },
        {
          icon: require("../../assets/images/userAuditBlue/icon4.png"),
          text: "放款",
        },
        {
          icon: require("../../assets/images/userAuditBlue/icon5.png"),
          text: "还款",
        },
      ],
      dropdownOption: [
        { text: "3期", value: 0, number: 3 },
        { text: "6期", value: 1, number: 6 },
        { text: "12期", value: 2, number: 12 },
        { text: "24期", value: 3, number: 24 },
      ],
    };
  },
  mounted() {
    this.getIsShieldCity();
    this.getDownloadUrl();
    window.history.pushState(null, document.title, window.location.href);
    this.preventBackButton();
    // 兼容苹果跳转回退不刷新页面（不触发mounted）
    var browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
    }
  },
  created() {
    this.handleUserResidenceTime();
    this.getAPIProduct();
    if (
      !window.localStorage.getItem("closePop") &&
      window.localStorage.getItem("backFlag") &&
      this.popData.productId
    ) {
      this.isShowPop = true;
    }
  },
  methods: {
    handlePopChange() {
      this.showPop = false;
    },
    preventBackButton() {
      window.addEventListener("popstate", () => {
        // 重新添加记录，使浏览器历史记录中当前页面的实例增加
        window.history.pushState(null, document.title, window.location.href);
        // 在这里可以添加用户尝试返回时想要执行的操作，比如弹窗提示
        this.isShowPop = true;
      });
    },
    //获取是否屏蔽城市
    getIsShieldCity() {
      API_Common.getIsShieldCity(this.channel)
        .then((res) => {
          // 检查返回的响应是否有效
          if (res && res.code === 200) {
            // 如果当前城市未被屏蔽
            if (res.data === false) {
              this.getChannleProductList();
              this.getPopProduct();
            } else {
              this.defaultDisplayData();
            }
          } else {
            // 如果响应不正常，或者城市被屏蔽，显示默认数据
            this.defaultDisplayData();
          }
        })
        .catch((error) => {
          // 处理请求失败的情况
          console.error("获取城市屏蔽状态失败:", error);
          this.defaultDisplayData(); // 请求失败时展示默认数据
        });
    },
    // 根据渠道code读取产品推荐信息 将权重最大的进行显示
    getChannleProductList() {
      API_Common.getProductsInResultPage(this.channel).then((res) => {
        if (res.code === 200) {
          let dataArr = res.data;
          if (dataArr.length > 0) {
            this.recommendProduct = {
              ...this.popData,
              ...(dataArr[0] || {}),
            };
            this.isProtocol =
              this.recommendProduct.protocolName &&
              this.recommendProduct.protocolUrl;
            this.btnTxt = "立即提现";
            this.productName = this.recommendProduct.name;
            if (this.recommendProduct.isToRegister === 1) {
              //获得联登的协议
              API_Common.getContent({
                pageType: this.model === "modeldlb" ? 36 : 40,
              }).then((res) => {
                this.apiProduct.content = res.data.content;
              });
            }
            this.changeOption(2);
          } else {
            this.defaultDisplayData();
          }
        } else {
          this.defaultDisplayData();
        }
      });
    },
    // 根据渠道code和进行到哪一步查询配置H5弹窗产品权重最大的值
    getPopProduct() {
      API_Common.getPopItem(this.channel).then((res) => {
        if (res.code === 200) {
          this.popData = {
            ...this.popData,
            ...(res.data || {}),
          };
        } else {
          this.productName = "放鑫钱包";
        }
      });
    },
    //API机构和授权书
    getAPIProduct() {
      var that = this;
      API_Common.getUser2WhereApi().then((res) => {
        if (res) {
          if (res.code === 200) {
            that.apiProduct = res.data;
          } else {
            this.$toast(res);
          }
        }
      });
    },
    //选择还款期数
    changeOption(options) {
      this.rate = this.recommendProduct.minLoanRate;
      if (this.rate === 0) {
        this.rate = 0.12;
      }
      this.showRate = (this.rate * 100)
        .toFixed(2)
        .replace(/(\.\d*?[1-9])0+$/, "$1");
      let number = this.dropdownOption[options].number;
      this.recommendProduct.number = 100000;
      this.interest = (
        ((this.recommendProduct.number * this.rate) / 12) *
        number
      ).toFixed(1);
      this.monthlyPayment = (
        this.interest / number +
        this.recommendProduct.number / number
      ).toFixed(1);
    },

    defaultDisplayData() {
      this.btnTxt = "立即下载";
      this.productName = "放鑫钱包";
      this.rate = 0.12;
      this.showRate = this.rate * 100;
      this.recommendProduct.minLoanRate = 0.12;
      this.recommendProduct.number = 100000;
      this.monthlyPayment = 9333.3;
      this.interest = 12000.0;
    },
    //同意协议
    handelAgreeProtocol() {
      window.localStorage.setItem("isClickProtocol", "ture");
      window.localStorage.setItem("backFlag", "true");
      window.localStorage.removeItem("closePop");
      const buriedData = {
        productId: this.recommendProduct.id,
        showPage: 5,
      };
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          this.recommendProduct.id,
          that.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            that.unionLogin = res.data;
          })
          .catch((error) => {})
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                productId: this.recommendProduct.id,
                showPage: 5,
              },
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },
    // 关闭协议弹窗
    handelCloseProtocol() {
      this.isShowProtocol = false;
    },

    //点击弹窗产品去申请
    handlePopBtn() {
      if (!this.checked) {
        this.$toast("请勾选同意个人信息查询授权书");
        return;
      }
      window.localStorage.setItem("closePop", "ture");
      window.localStorage.removeItem("backFlag");
      const buriedData = {
        productId: this.popData.productId,
        showPage: 7,
      };
      // toRedirectUrlAndSaveRecordNoDebounce(url, buriedData);
      let redirectUrl = this.popData.linkUrl; //默认跳转url
      let isWeCom = this.popData.isWeCom;
      if (this.popData.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.popData.productId,
          this.popData.hitRecordId
        )
          .then((res) => {
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch((error) => {
            console.error("getRegister2CompanyUrl failed:", error);
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.popData.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          that.popData?.productId,
          that.popData?.hitRecordId
        )
          .then(async (res) => {
            that.unionLogin = res.data;
          })
          .catch((error) => {})
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                productId: that.popData.productId,
                showPage: 7,
              },
              isWeCom
            );
          });
      } else {
        toRedirectUrlAndSaveRecordNoDebounce(redirectUrl, buriedData, isWeCom);
      }
    },
    //cpa取消弹窗
    handleCancelBtn() {
      this.isShowPop = false;
      window.localStorage.setItem("closePop", "ture");
      window.localStorage.removeItem("backFlag");
    },
    //点击底部按钮
    handleSubmit() {
      if (this.popData.isShieldCity || !this.recommendProduct.id) {
        this.handleDownload(1);
      } else {
        this.isShowProtocol = true;
      }
    },
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url;
        }
      });
    },
    handlePopLoginProtocol() {
      window.location.href = this.popData.protocolUrl;
    },
    //点击联登协议
    handleLoginProtocol() {
      window.location.href = this.recommendProduct.protocolUrl;
    },

    handleProtocol(pageType) {
      if (pageType === 12) {
        let userId = window.localStorage.getItem("userId");
        window.location.href =
          "/protocol.html?pageType=" + pageType + "&userId=" + userId;
      } else {
        window.location.href = "/protocol.html?pageType=" + pageType;
      }
    },
    //type 1func-button
    handleDownload(type) {
      addDownloadRecord(this.channel);
      let isWeixin = this.isWeixin();
      if (this.model === "model14" || this.model === "model15") {
        API_Common.getDownloadUrlWithHaier(
          this.channel,
          this.model === "model14" ? 1 : 2
        ).then((res) => {
          if (res.code === 200) {
            this.downAppUrl = res.data.url;
            this.$bridge.callhandler(
              "openExternalBrowser",
              { jumpUrl: this.downAppUrl },
              (data) => {
                // 处理返回数据
                console.log(data);
              }
            );
          }
        });
      } else if (this.channel === "wxqd" && isWeixin) {
        this.handleCopyDownloadURL(type);
      } else {
        window.location.href = this.downAppUrl;
      }
    },
    async handleCopyDownloadURL(type) {
      let that = this;
      let clipboard;
      if (type === 1) {
        clipboard = new ClipboardJS(".func-button", {
          text: function () {
            return that.downAppUrl;
          },
        });
      } else {
        clipboard = new ClipboardJS(".download-button", {
          text: function () {
            return that.downAppUrl;
          },
        });
      }

      clipboard.on("success", function (e) {
        that.$toast("复制下载链接成功,请前往浏览器打开链接");
      });
      clipboard.on("error", function (e) {
        that.$toast("复制失败");
      });
    },

    handleUserResidenceTime() {
      API_Common.delayModel8SUpdate(this.channel, 0, 0, 5);
    },
  },
};
</script>

<style scoped>
@import "../../css/userAuditBlue.css";
@import "../../css/cpaPopView.scss";
@import "../../css/protocolPopView.css";
@import "../../css/xybPopView.css";

/deep/ .van-dropdown-menu__bar {
  box-shadow: unset !important;
  height: 0.35rem;
}

/deep/ .van-popup--top {
  left: 5.2rem;
  width: 25%;
  box-shadow: 2px 2px 4px 2px #999 inset;
}

/deep/ .van-dropdown-item__option {
  opacity: 0.9; /* 整个元素 50% 透明度 */
}

/deep/ .van-cell::after {
  border-bottom: 0px solid #ebedf0;
}
/deep/ .van-dropdown-menu__title--active {
  color: #1d52ff !important;
}
/deep/ .van-dropdown-item__option--active {
  color: #1d52ff !important;
}

.share-pop {
  color: #fff;
  font-size: 0.32rem;
}
.icon-share {
  display: block;
  width: 3.38rem;
  height: 4.8rem;
  position: absolute;
  right: 0.44rem;
  top: 0.34rem;
  transform: rotate(-12deg);
}
.share-font-box {
  width: 100%;
  padding: 0 0.88rem;
  position: absolute;
  top: 5.2rem;
  left: 0;
}
.share-font {
  font-family: PingFangSC, PingFangSC-Regular, serif;
  font-weight: 400;
  line-height: 0.44rem;
}

.share-btn {
  width: 1.76rem;
  height: 0.72rem;
  border: 1px solid #ffffff;
  border-radius: 4px;
  margin: 20.6rem auto 0;
}

.po_button_1 {
  background-color: #1d52ff;
  border-radius: 20px;
  height: 40px;
  width: 263px;
  margin: 19px 0 20px 36px;
}
</style>
